module.exports = __webpack_public_path__ + "img/logo-colegiados1.463b77cb.svg";